<div>
    <h1>Kyberna web ADMIN</h1>

    <button type="button" class="primary" (click)="login()">Přihlásit se pomocí školního účtu</button>
</div>
<!-- <button type="button" (click)="logout()">Logout</button> -->